<template>
<el-button type="primary"  color=" #326EFF" size="default" >
  <slot></slot>
</el-button>
</template>

<script>
export default {
  name: "yzButton1"
}
</script>

<style scoped>

</style>
